/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";

/**
 *
 * @export
 * @interface ReportBase
 */
export interface ReportBaseOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportBase
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof ReportBase
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportBase
   */
  reportStatus?: ReportStatus;
}

export interface ReportBase extends ReportBaseOptional, Deletable {
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportBase
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof ReportBase
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportBase
   */
  reportStatus?: ReportStatus;
}

export interface ReportBaseTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportBase
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportBase
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportBase
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof ReportBase
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportBase
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
}

transformDatesMap.set("ReportBase", function (model: ReportBase) {});

export type ReportBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
}>;

export var ReportBaseMeta: ReportBaseMetaI = {} as ReportBaseMetaI;
ReportBaseMeta = typeMeta("ReportBase", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
});

const metaI = ReportBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class ReportBaseTracked
  extends DeletableTracked
  implements ReportBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  constructor(config?: ReportBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }
  }
  assignFrom(
    config: ReportBaseOptional,
    options?: AssignOptions,
  ): ReportBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ReportBaseTrackedI {
    const cloned = {} as ReportBaseTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ReportBaseTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportBaseMeta.isDeleted,
      ReportBaseMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportBaseMeta.isNew, ReportBaseMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportBaseMeta.reportId, ReportBaseMeta, this.reportId, this);
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportBaseMeta.reportKey,
      ReportBaseMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportBaseMeta.reportTitle,
      ReportBaseMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportBaseMeta.reportType,
      ReportBaseMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportBaseMeta.reportStatus,
      ReportBaseMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
